export default __webpack_public_path__ + "static/media/Criterion-Logo.31eda96a.jpg";